export function sendConversion(conversion_id, conversion_label, value, eventCallback) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'conversion',
        eventModel: {
            conversion_id: conversion_id,
            conversion_label: conversion_label,
            event_value: value || null,
            currency: 'USD',
        },
        eventCallback: eventCallback || function(){}
    });
}
